import { Table, Td, Th, Tr } from 'app/common/ui-components/table'
import { EncashmentsDetailsType, EncashmentsStatusType, EncashmentsSummaryType } from 'app/dataTypes/reports/data'
import { TimeCell } from './TimeCell'
import { RefCallback } from 'react'
import styles from './SubTableInfo.module.scss'
import { StatusMessage } from 'app/common/templates-next/page-template'


type Props = {
  encashmentsDetails: EncashmentsDetailsType[]
  encashmentsSummary: EncashmentsSummaryType
  headerRef: RefCallback<'tr'>
}

export const SubTableInfo = ({
  encashmentsDetails,
  encashmentsSummary,
  headerRef,
}: Props) => {
  const { status, comment } = encashmentsSummary

  if (!encashmentsDetails.length && comment) {
    return (
      <StatusMessage>{'Нет данных'}</StatusMessage>
    )
  }

  return (
    <>
      <Table wide>
        <thead>
          <Tr header reference={headerRef}>
            <Th className="index_0" alignLeft>{'Номер инкассации'}</Th>
            <Th className="index_1">{''}</Th>
            <Th className="index_2">{''}</Th>
            <Th className="index_3">{''}</Th>
            <Th className="index_4">{''}</Th>
            <Th className="index_4">{''}</Th>
            <Th className="index_5">{''}</Th>
            <Th className="index_6">{''}</Th>
          </Tr>
        </thead>
        <tbody>
          {encashmentsDetails.map(({ id, balanceAtTheBeginning, balanceAtTheEnd, collected, revenue, time }) => (
            <Tr key={id}>
              <Td>{id}</Td>
              <Td>
                <TimeCell time={time} />
              </Td>
              <Td alignRight>{balanceAtTheBeginning}</Td>
              <Td alignRight>{revenue}</Td>
              <Td alignRight>{collected}</Td>
              <Td alignRight>{balanceAtTheEnd}</Td>
              <Td >{''}</Td>
              <Td >{''}</Td>
            </Tr>
          ))}
        </tbody>
      </Table>
      {status === EncashmentsStatusType.CashRefused && <div className={styles.statusMessage}>Причина отказа: {comment}</div>}
    </>
  )
}
